export default "__VITE_ASSET__D5QO_6ge__"